"use client"

import { FeedData as Feed } from "@extractus/feed-extractor"

interface FeedDescriptionProps {
  feed: Feed
}

export function FeedDescription({ feed }: FeedDescriptionProps) {
  // Check if the feed is empty or lacking entries
  const isEmpty = !feed.entries || feed.entries.length === 0

  if (isEmpty) {
    return (
      <div className="space-y-4">
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-destructive">
            Feed not found — did you enter the correct URL?
          </h3>
          <p className="text-sm text-muted-foreground">
            We couldn't find any posts at the URL you provided. Please try one
            of these options:
          </p>
          <ul className="pl-6 text-sm list-disc space-y-1 text-muted-foreground">
            <li>Check that the URL is correct and links to a valid RSS feed</li>
            <li>Upload an XML export file from your blogging platform</li>
          </ul>
        </div>
      </div>
    )
  }

  // If feed has entries, show normal content
  const entries = feed.entries || []

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-base font-semibold">
          Feed found: {feed.title || "RSS feed"}
        </h3>
        <p className="text-sm text-muted-foreground">
          We found {entries.length} posts in your feed.
        </p>
      </div>

      <div className="space-y-1">
        <p className="text-sm font-medium">Recent posts:</p>
        <ul className="pl-6 text-sm list-disc space-y-1">
          {entries.slice(0, 3).map((entry, i) => (
            <li key={i} className="text-muted-foreground">
              {entry.title}
            </li>
          ))}
          {entries.length > 3 && (
            <li className="text-muted-foreground">
              ...and {entries.length - 3} more
            </li>
          )}
        </ul>
      </div>

      <p className="text-sm text-muted-foreground">
        If you want to include full post content, you may need to upload an XML
        export file.
      </p>
    </div>
  )
}
